import React from 'react';
import "../template-file-css/document-file-template.css";


export const KE_SubstanceAbuse = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='KE_SubstanceAbuse' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h4>SUBSTANCE ABUSE PROBATION PROGRAM PROGRESS REPORT</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>District:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Agent:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDistrict' name='txtDistrict' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAgent' name='txtAgent' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOCKET #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDocketNumber' name='txtDocketNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> Level of Care:</span>
                    <input type='checkbox' id='cbOutpatient' name='cbOutpatient' className='add-only' value='Outpatient' /> Outpatient <br />
                    <input type='checkbox' id='cbIntensiveOutpatient' name='cbIntensiveOutpatient' className='add-only' value='Intensive Outpatient' /> Intensive Outpatient
                </p>

                <p className='w-750'>Circle Dates of Sessions Attended for the month of &nbsp; <input type='text' id='txtMonth' name='txtMonth' placeholder='Month' className='add-only w-150 custom-add-only' />, &nbsp; 20 &nbsp; <input type='text' id='txtYear' name='txtYear' placeholder='Year' className='add-only w-100 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_1' name='cbCircleDates_1' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_2' name='cbCircleDates_2' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_3' name='cbCircleDates_3' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_4' name='cbCircleDates_4' className='add-only' value='4' /> 4 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_5' name='cbCircleDates_5' className='add-only' value='5' /> 5 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_6' name='cbCircleDates_6' className='add-only' value='6' /> 6
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_7' name='cbCircleDates_7' className='add-only' value='7' /> 7 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_8' name='cbCircleDates_8' className='add-only' value='8' /> 8 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_9' name='cbCircleDates_9' className='add-only' value='9' /> 9
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_10' name='cbCircleDates_10' className='add-only' value='10' /> 10
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_11' name='cbCircleDates_11' className='add-only' value='11' /> 11 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_12' name='cbCircleDates_12' className='add-only' value='12' /> 12 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_13' name='cbCircleDates_13' className='add-only' value='13' /> 13
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_14' name='cbCircleDates_14' className='add-only' value='14' /> 14 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_15' name='cbCircleDates_15' className='add-only' value='15' /> 15 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_16' name='cbCircleDates_16' className='add-only' value='16' /> 16
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_17' name='cbCircleDates_17' className='add-only' value='17' /> 17 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_18' name='cbCircleDates_18' className='add-only' value='18' /> 18 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_19' name='cbCircleDates_19' className='add-only' value='19' /> 19
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_20' name='cbCircleDates_20' className='add-only' value='20' /> 20
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_21' name='cbCircleDates_21' className='add-only' value='21' /> 21 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_22' name='cbCircleDates_22' className='add-only' value='22' /> 22 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_23' name='cbCircleDates_23' className='add-only' value='23' /> 23
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_24' name='cbCircleDates_24' className='add-only' value='24' /> 24 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_25' name='cbCircleDates_25' className='add-only' value='25' /> 25 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_26' name='cbCircleDates_26' className='add-only' value='26' /> 26
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_27' name='cbCircleDates_27' className='add-only' value='27' /> 27 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_28' name='cbCircleDates_28' className='add-only' value='28' /> 28 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_29' name='cbCircleDates_29' className='add-only' value='29' /> 29
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_30' name='cbCircleDates_30' className='add-only' value='30' /> 30
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbCircleDates_31' name='cbCircleDates_31' className='add-only' value='31' /> 31
                        </td>
                    </tr>
                </table>

                <p className='w-750'>Circle Dates of Missed Sessions for the month of &nbsp; <input type='text' id='txtMonth_1' name='txtMonth_1' placeholder='Month' className='add-only w-150 custom-add-only' />, &nbsp; 20 &nbsp; <input type='text' id='txtYear_1' name='txtYear_1' placeholder='Year' className='add-only w-100 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_1' name='cbMissedSessions_1' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_2' name='cbMissedSessions_2' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_3' name='cbMissedSessions_3' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_4' name='cbMissedSessions_4' className='add-only' value='4' /> 4 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_5' name='cbMissedSessions_5' className='add-only' value='5' /> 5 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_6' name='cbMissedSessions_6' className='add-only' value='6' /> 6
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_7' name='cbMissedSessions_7' className='add-only' value='7' /> 7 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_8' name='cbMissedSessions_8' className='add-only' value='8' /> 8 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_9' name='cbMissedSessions_9' className='add-only' value='9' /> 9
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_10' name='cbMissedSessions_10' className='add-only' value='10' /> 10
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_11' name='cbMissedSessions_11' className='add-only' value='11' /> 11 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_12' name='cbMissedSessions_12' className='add-only' value='12' /> 12 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_13' name='cbMissedSessions_13' className='add-only' value='13' /> 13
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_14' name='cbMissedSessions_14' className='add-only' value='14' /> 14 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_15' name='cbMissedSessions_15' className='add-only' value='15' /> 15 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_16' name='cbMissedSessions_16' className='add-only' value='16' /> 16
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_17' name='cbMissedSessions_17' className='add-only' value='17' /> 17 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_18' name='cbMissedSessions_18' className='add-only' value='18' /> 18 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_19' name='cbMissedSessions_19' className='add-only' value='19' /> 19
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_20' name='cbMissedSessions_20' className='add-only' value='20' /> 20
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_21' name='cbMissedSessions_21' className='add-only' value='21' /> 21 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_22' name='cbMissedSessions_22' className='add-only' value='22' /> 22 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_23' name='cbMissedSessions_23' className='add-only' value='23' /> 23
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_24' name='cbMissedSessions_24' className='add-only' value='24' /> 24 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_25' name='cbMissedSessions_25' className='add-only' value='25' /> 25 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_26' name='cbMissedSessions_26' className='add-only' value='26' /> 26
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_27' name='cbMissedSessions_27' className='add-only' value='27' /> 27 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_28' name='cbMissedSessions_28' className='add-only' value='28' /> 28 </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_29' name='cbMissedSessions_29' className='add-only' value='29' /> 29
                        </td>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_30' name='cbMissedSessions_30' className='add-only' value='30' /> 30
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <input type='checkbox' id='cbMissedSessions_31' name='cbMissedSessions_31' className='add-only' value='31' /> 31
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> Level of Participation:</span>
                    <input type='checkbox' id='cbExcellent' name='cbExcellent' className='add-only' value='Excellent' /> Excellent &nbsp;
                    <input type='checkbox' id='cbSatisfactory' name='cbSatisfactory' className='add-only' value='Satisfactory' /> Satisfactory &nbsp;
                    <input type='checkbox' id='cbPoor' name='cbPoor' className='add-only' value='Poor' /> Poor
                </p>

                <p className='w-750'><span className='eleHeader'> Progress:</span>
                    <input type='checkbox' id='cbSignificant' name='cbSignificant' className='add-only' value='Significant Improvement' /> Significant Improvement &nbsp;
                    <input type='checkbox' id='cbMarginal' name='cbMarginal' className='add-only' value='Marginal Improvement' /> Marginal Improvement &nbsp;
                    <input type='checkbox' id='cbNoImprovement' name='cbNoImprovement' className='add-only' value='No Improvement' /> No Improvement
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Urine Screens--Dates/Results:</span>
                    <textarea id='txtUrineScreens' name='txtUrineScreens' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Date Completed/Removed from Program:</span>
                    <input type='text' id='txtDateCompleted' name='txtDateCompleted' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Reason:</span>
                    <textarea id='txtReason' name='txtReason' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-350'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-350'> Completed by: </td>
                        <td className='small w-200'> Title: </td>
                        <td className='small w-200'> Phone/Fax </td>
                    </tr>
                </table>


            </div>
        </form>
    )
}